import { render, staticRenderFns } from "./AppPaginaBarraSuperior.vue?vue&type=template&id=d83638f4&"
import script from "./AppPaginaBarraSuperior.vue?vue&type=script&lang=js&"
export * from "./AppPaginaBarraSuperior.vue?vue&type=script&lang=js&"
import style0 from "./AppPaginaBarraSuperior.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports